import React, { useEffect, useState } from "react";
import { selectCaseStates, selectCaseSubStatesLoading,  selectCaseSubStatesPag } from "../../redux/caseStates/selectors";
import { useDispatch, useSelector } from "react-redux";
import { Column } from "devextreme-react/data-grid";
import { AdminTable } from "./AdminTable";
import { createSubState, deleteSubState, getCaseStates, getCaseSubStatesPag, updateSubState } from "../../redux/caseStates/thunks";
import { openModal } from "../../redux/modal/modalSlice";

const initialSortOptions = {
    columna: "subStateId",
    sortOrderAsc: true

}

function SubStatesManagement() { 
    const subStates = useSelector(selectCaseSubStatesPag);
    const states = useSelector(selectCaseStates);
    const dispatch = useDispatch();
    const loading = useSelector(selectCaseSubStatesLoading);
    const [sortOptions, setSortOptions] = useState(initialSortOptions)


    const columnsSubstates = [
        <Column key={"subState-1"} dataType={"string"} sortIndex={1} dataField="description" caption="Descrição" />, 
        <Column key={"subState-2"} dataField={"parentStateId"} caption="Estado pai" lookup={{multiple: false, allowClearing: true, dataSource: states, displayExpr: "description", valueExpr: "stateId"}}/>
    ]    

    useEffect(()=>{
        getListCaseSubStates(mapPageInfo(subStates));
        dispatch(getCaseStates());
        
    },[])

    function mapPageInfo(statesData){
        return {
            pageIndex: statesData.pageIndex ?? 0,
            pageSize: statesData.pageSize ?? 10,
            orderByField: statesData.columna ?? "subStateId",
            orderByAscending: statesData.sortOrderAsc ?? true
        }
    }

    const getListCaseSubStates = (pageInfo) => {
        let query= `?pageIndex=${pageInfo.pageIndex}&pageNum=${pageInfo.pageSize}`
        if(pageInfo.searchString?.trim().length > 0){
            query = query.concat(`&searchString=${pageInfo.searchString.trim()}`)
        }
        if(pageInfo.orderByField)
            {
                query = query.concat(`&orderByField=${pageInfo.orderByField}&orderByAscending=${pageInfo.orderByAscending}`)
            }
        dispatch(getCaseSubStatesPag({query}));
    }

    function handleSaveNewStateClick(value, closeCreateModal) {    
        const caseStateParams = {body: value}
        dispatch(createSubState(caseStateParams)).then((data) => {
                if(data.error)
                    dispatch(openModal({ type: "warning", message:data.error.message}))
                else{
                     getListCaseSubStates(mapPageInfo({...subStates, ...sortOptions}));
                     closeCreateModal()
                    }                    
                })     
    }    

    const handleEditClick = (value, closeEditModal) => {
        const editCaseStateParams ={
                    stateId: value.stateId,
                    body: value
                }
                dispatch(updateSubState(editCaseStateParams)).then((data) => {
                    if(data.error)
                        dispatch(openModal({ type: "warning", message:data.error.message}))
                    else{
                        getListCaseSubStates(mapPageInfo({...subStates, ...sortOptions}));
                        closeEditModal();
                    }
                        
                })      
    }

    const handleDeleteClick = (subStateId, closeDeleteModal) => {
        dispatch(deleteSubState({query:subStateId})).then((data) => {
            if(data.error)
                dispatch(openModal({ type: "warning", message:data.error.message}))
            else{
                let updatedPageIndex = subStates.pageIndex;

                if (subStates.elements.length === 1) {
                    updatedPageIndex = Math.max(0, subStates.pageIndex - 1);
                }

                const updatedStates = {
                    ...subStates,
                    pageIndex: updatedPageIndex,
                };
                getListCaseSubStates(mapPageInfo({...updatedStates, ...sortOptions}));
                closeDeleteModal()            
            }
        })  
    } 

    function allowDelete(rowData){
        return rowData.data.custom;
    }

    return(
        <div style={{width: "100%"}}>
            <AdminTable 
                sectionTitle={"Sub-estados"}
                masterTitle={"Sub-estado"} 
                itemIdField={"subStateId"} 
                itemDescriptionField={"description"} 
                loading={loading} 
                getData={getListCaseSubStates} 
                dataSource={subStates} 
                columnasTabla={columnsSubstates} 
                onCreate={handleSaveNewStateClick}
                onDelete={handleDeleteClick}
                onEdit={handleEditClick} 
                numElements={[10, 20, 30]}
                allowDelete={allowDelete}
                sortField={sortOptions}
                setsortField={setSortOptions}
            />
        </div>
    )
} 

export {SubStatesManagement}